/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsPortfolioIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsPortfolioIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioIdQueryOperator>): AppSecopsPortfolioIdQueryOperator {
        let obj = Object.assign(new AppSecopsPortfolioIdQueryOperator(), model);
        AppSecopsPortfolioIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioIdQueryOperator>): AppSecopsPortfolioIdQueryOperator {
        if (!model) return null;
        return AppSecopsPortfolioIdQueryOperator.newInstance(<AppSecopsPortfolioIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsPortfolioIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Portfolio IDs to include
     */
    portfolio_ids: Array<string>;

}
